import React from 'react';
import PropTypes from 'prop-types';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import printIcon from './print-icon.svg';
import printIconImage from './print.png';
import styles from './PrintButton.module.scss';

export default function PrintButton(props) {
  return (
    <TCITooltip side={props.placement}>
      <TCITooltip.Trigger asChild>
        <a
          aria-label={props.tooltipText}
          className={styles[props.wrapperClass]}
          href={props.pdfPath}
          rel="noopener noreferrer"
          target="_blank"
        >
          {props.useNewIcon ? (
            <Icon icon="Print" size={props.iconSize} />
          ) : (
            <span className={styles.print}>
              <img
                alt=""
                className={styles.printIcon}
                src={(props.icon === 'print.png' ?
                  printIconImage : props.icon) || printIcon}
              />
            </span>
          )}
          <span className="sr-only">{props.tooltipText}</span>
        </a>
      </TCITooltip.Trigger>
      <TCITooltip.Content>
        {props.tooltipText}
      </TCITooltip.Content>
    </TCITooltip>
  );
}

PrintButton.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  pdfPath: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  tooltipText: PropTypes.string,
  useNewIcon: PropTypes.bool,
  wrapperClass: PropTypes.string,
};

PrintButton.defaultProps = {
  icon: null,
  iconSize: 30,
  placement: 'top',
  tooltipText: 'Print Text',
  useNewIcon: true,
  wrapperClass: '',
};
